import {getWhatsAppTemplateByIdUseCase} from '@/useCases/getWhatsAppTemplateByIdUseCase'
import {useQuery} from '@tanstack/react-query'

export const useGetWhatsAppTemplateDetails = (whatsappTemplateId?: string) => {
  const {isFetching, data, error} = useQuery({
    queryKey: ['whatsapp-template-details', whatsappTemplateId],
    queryFn: ({signal}) => getWhatsAppTemplateByIdUseCase({id: whatsappTemplateId ?? ''}, signal),
    enabled: !!whatsappTemplateId,
  })

  return {
    isFetching,
    data,
    error,
  }
}
